import {useMemo} from 'react';
import {useMe} from 'hooks';

interface IUseCheckPlanProps<T> {
  featureId: string;
  isDataFetching: boolean;
  data: T[];
}

const useCheckPlan = <T>({featureId, isDataFetching, data}: IUseCheckPlanProps<T>) => {
  const me = useMe();
  const plan = me?.plan;

  const isLimitReached = useMemo(() => {
    const features = plan?.featuresOverride || plan?.features;
    if (!isDataFetching && features) {
      const limit = features.find(f => f?.id === featureId)?.value ?? 0;
      return typeof limit === 'number' ? data.length >= limit : true;
    }
    return true;
  }, [isDataFetching, plan, data]);

  return {isLimitReached};
};

export default useCheckPlan;
